import { useEffect } from 'react'

function useEsc(handler) {
  useEffect(() => {
    function handlePressKeys(e) {
      const key = e.which || e.keyCode
      if (key === 27) {
        handler()
        e.preventDefault()
      }
    }

    document.addEventListener('keydown', handlePressKeys)

    return () => document.removeEventListener('keydown', handlePressKeys)
  })
}

export default useEsc
